import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=59422695&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59422695')) {
      api.createRecord('59422695', component.options)
    } else {
      api.reload('59422695', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=59422695&", function () {
      api.rerender('59422695', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/consign/return/detail.vue"
export default component.exports